<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="title"
      [size]="'medium'"
      [showCloseButton]="false"
      [closeOnBackdropClick]="false"
      [isLoading]="isLoading()"
      [ariaLabelledBy]="'phone-auth-modal-title'"
      (closeModal)="onCancel()"
    >
      <div modal-content>
        <div class="flex justify-center mb-4">
          <div class="w-12 h-12 rounded-full flex items-center justify-center">
            <ld-svg-icon [src]="annotationIcon" class="w-6 h-6" aria-hidden="true" />
          </div>
        </div>

        <p id="phone-auth-modal-message" class="text-body text-ld-neutral-500 text-justify mb-4">
          {{ message }}
        </p>
      </div>

      <div modal-footer class="flex flex-row items-center justify-end gap-4">
        <button
          id="phone-auth-modal-cancel-btn"
          type="button"
          class="text-ld-neutral-500 font-dm font-medium text-sm cursor-pointer bg-transparent border-0 hover:text-ld-neutral-700 transition-colors"
          [disabled]="isLoading()"
          (click)="onCancel()"
        >
          {{ cancelText }}
        </button>

        <button
          id="phone-auth-modal-confirm-btn"
          type="button"
          cdkFocusInitial
          [class]="mode() === 'authorize' ? 'btn-primary-ld-purple' : 'btn-solid-red'"
          [disabled]="isLoading()"
          (click)="onConfirm()"
        >
          @if (isLoading()) {
            <mat-spinner diameter="16" class="w-4! h-4!"></mat-spinner>
          }
          {{ confirmText }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
